module.exports = __webpack_public_path__ + "static/img/product2-1.b4907dc5.png";